const locale = {
	CONTACT: '聯絡擎億',
	ISO: 'ISO 9001',
	MINERALS: '礦產政策',
	PRODUCTS: '擎億產品',
	HOME: '擎億首頁',
	footerCompany: '擎億精密有限公司',
	footerTagline: '瑞士型走心機 CNC 精密加工 ｜ φ1–20mm 小徑精密零件，公差 ±0.005mm，ISO 9001:2015 認證。',
	footerLinks: '快速連結',
	footerContactTitle: '聯絡資訊',
	footerAddress: '新北市樹林區備內街1巷35弄5號',
	footerPhone: '0966-686-161 ／ 02-8687-2058',
	footerEmail: 'qingyi106@gmail.com',
	footerRights: '© 2026 擎億精密有限公司. 版權所有.'
};

export default locale;
